import { render } from "./PlotRent.vue?vue&type=template&id=08850e05&scoped=true"
import script from "./PlotRent.vue?vue&type=script&lang=js"
export * from "./PlotRent.vue?vue&type=script&lang=js"

import "./PlotRent.vue?vue&type=style&index=0&id=08850e05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08850e05"]])

export default __exports__